import React from 'react';
import { Box, Container } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export default function PageLayout({
  children,
  maxWidth = 'xl',
  disablePadding = false,
  backgroundAccent = false,
  compact = false,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        px: disablePadding ? 0 : { xs: 0.75, sm: 1.5, lg: 2.25 },
        py: disablePadding ? 0 : compact ? { xs: 1, sm: 1.5 } : { xs: 1.4, sm: 2.2 },
      }}
    >
      {backgroundAccent ? (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            background: theme.hr?.gradient?.page ||
              (theme.palette.mode === 'dark'
                ? `radial-gradient(1000px 260px at 0% 0%, ${alpha(theme.palette.secondary.main, 0.14)}, transparent 55%),` +
                  `radial-gradient(900px 240px at 100% 0%, ${alpha(theme.palette.primary.main, 0.2)}, transparent 58%)`
                : `radial-gradient(1000px 260px at 0% 0%, ${alpha(theme.palette.secondary.main, 0.09)}, transparent 55%),` +
                  `radial-gradient(900px 240px at 100% 0%, ${alpha(theme.palette.primary.main, 0.11)}, transparent 58%)`),
          }}
        />
      ) : null}

      <Container
        maxWidth={maxWidth}
        sx={{
          position: 'relative',
          px: { xs: 0.5, sm: 1, md: 1.25 },
        }}
      >
        {children}
      </Container>
    </Box>
  );
}

